import {MainStore} from './MainStore';
import {UserStore} from './UserStore';
import {AuthStore} from './AuthStore';
import {PageCatalogStore} from './page/PageCatalogStore';
import {PageMainStore} from "./page/PageMainStore";
import {PageRegAllStore} from "./page/PageRegAllStore";
import {PageCardStore} from "./page/PageCardStore";
import {PagePersonalStore} from "./page/PagePersonalStore";
import {ComFilterCatalogStore} from "./component/ComFilterCatalogStore";
import {PageRegEmployeeStore} from "./page/PageRegEmployeeStore";
import {PageRegTradePointStore} from "./page/PageRegTradePointStore";
import {PageChangeStore} from "./page/PageChangeStore";
import {ComCatalogSectionStore} from "./component/ComCatalogSectionStore";
import {BasePageStore} from "./BasePageStore";
import {ComTopSearchStore} from "./component/ComTopSearchStore";
import {PageCommercialStore} from "./page/PageCommercialStore";
import {PageBasketStore} from "./page/PageBasketStore";
import {PageOrderStore} from "./page/PageOrderStore";
import {PageOrderDetailStore} from "./page/PageOrderDetailStore";
import {PageReturnStore} from "./page/PageReturnStore";
import {ComBasketCountStore} from "./component/ComBasketCountStore";
import {PageMassageStore} from "./page/PageMassageStore";
import {PageClientsStore} from "./page/PageClientsStore";
import {PageAdminAuthStore} from "./page/PageAdminAuthStore";
import {PageConfirmStore} from "./page/PageConfirmStore";
import {PageAdminEmailReplayStore} from "./page/PageAdminEmailReplayStore";
import {PageDopInfoStore} from "./page/PageDopInfoStore";
import {BannerStore} from "./page/BannerStore";
import {PageBrandsStore} from "./page/PageBrandsStore";
import {PageQuizStore} from "./page/PageQuizStore";
import {PagePaymentStore} from "./page/PagePaymentStore";
import {PageAdminUserLogStore} from "./page/PageAdminUserLogStore";


export class RootStore {
    mainStore: MainStore;
    userStore: UserStore;
    authStore: AuthStore;

    basePageStore: BasePageStore;
    pageCatalogStore: PageCatalogStore;
    pageMainStore: PageMainStore;
    pageRegAllStore: PageRegAllStore;
    pageCardStore: PageCardStore;
    pageRegEmployeeStore: PageRegEmployeeStore;
    pageChangeStore: PageChangeStore;
    pageConfirmStore: PageConfirmStore;
    pageRegTradePointStore: PageRegTradePointStore;
    pagePersonalStore: PagePersonalStore;
    pageCommercialStore: PageCommercialStore;
    pageBasketStore: PageBasketStore;
    pageOrderStore: PageOrderStore;
    pageReturnStore: PageReturnStore;
    pageOrderDetailStore: PageOrderDetailStore;
    pageMassageStore: PageMassageStore;
    pageClientsStore: PageClientsStore;
    componentFilterCatalogStore: ComFilterCatalogStore;
    pageDopInfoStore: PageDopInfoStore;
    bannerStore: BannerStore;
    pageBrandsStore: PageBrandsStore;
    pageQuizStore: PageQuizStore;
    pagePaymentStore: PagePaymentStore;

    // ADMINS
    pageAdminAuthStore: PageAdminAuthStore;
    pageAdminUserLogStore: PageAdminUserLogStore;
    pageAdminEmailReplayStore: PageAdminEmailReplayStore;

    componentCatalogSectionStore: ComCatalogSectionStore;
    componentTopSearchStore: ComTopSearchStore;
    componentBasketCountStore: ComBasketCountStore;

    constructor() {
        this.mainStore = new MainStore(this);
        this.userStore = new UserStore(this);
        this.authStore = new AuthStore(this);
        // PAGE BASE TITLE AND BreadCrumbs
        this.basePageStore = new BasePageStore(this);
        // PAGE
        this.pageCatalogStore = new PageCatalogStore(this);
        this.pageMainStore = new PageMainStore(this);
        this.pageRegAllStore = new PageRegAllStore(this);
        this.pageCardStore = new PageCardStore(this);
        this.pageRegEmployeeStore = new PageRegEmployeeStore(this);
        this.pageRegTradePointStore = new PageRegTradePointStore(this);
        this.pageChangeStore = new PageChangeStore(this);
        this.pageConfirmStore = new PageConfirmStore(this);
        this.pagePersonalStore = new PagePersonalStore(this);
        this.pageCommercialStore = new PageCommercialStore(this);
        this.pageBasketStore = new PageBasketStore(this);
        this.pageOrderStore = new PageOrderStore(this);
        this.pageReturnStore = new PageReturnStore(this);
        this.pageOrderDetailStore = new PageOrderDetailStore(this);
        this.pageMassageStore = new PageMassageStore(this);
        this.pageClientsStore = new PageClientsStore(this);
        this.pageDopInfoStore = new PageDopInfoStore(this);
        this.bannerStore = new BannerStore(this);
        this.pageBrandsStore = new PageBrandsStore(this);
        this.pageQuizStore = new PageQuizStore(this);
        this.pagePaymentStore = new PagePaymentStore(this);
        // ADMINS
        this.pageAdminAuthStore = new PageAdminAuthStore(this);
        this.pageAdminEmailReplayStore = new PageAdminEmailReplayStore(this);
        this.pageAdminUserLogStore = new PageAdminUserLogStore(this);

        //component
        this.componentFilterCatalogStore = new ComFilterCatalogStore(this);
        this.componentCatalogSectionStore = new ComCatalogSectionStore(this);
        this.componentTopSearchStore = new ComTopSearchStore(this);
        this.componentBasketCountStore = new ComBasketCountStore(this);

        this.inits();
    }

    private inits() {
        this.mainStore.init();
    }

}

